export const SET_USER = 'SET_USER';
export const SET_BASEURL = 'SET_BASEURL';




// WEBPACK FOOTER //
// ./src/store/mutation-types.js